import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import useRemoveHash from '../../utils/router/useRemoveHash';
import commentThreadHash from '../../utils/url/commentThreadHash';

const THREAD_FRAGMENT = gql(`
  fragment useResolveThread_thread on RootThreadFields {
    id
  }
`);

const RESOLVE_THREAD_MUTATION = gql(/** @complexity 2 */ `
  mutation resolveThread($id: ID!) {
    resolveThread(threadId: $id) {
      id
    }
  }
`);

const useResolveThread = (thread: DocumentType<typeof THREAD_FRAGMENT>) => {
  const removeHash = useRemoveHash();

  const [mutation] = useMutation(RESOLVE_THREAD_MUTATION, {
    variables: { id: thread.id },
    optimisticResponse: { resolveThread: { id: thread.id } },
    update: (cache) => {
      cache.modify({
        id: cache.identify(thread),
        fields: {
          resolvedAt: () => new Date().toISOString(),
        },
      });
    },
  });

  return useCallback(async () => {
    await mutation();
    if (window.location.hash === commentThreadHash(thread.id)) {
      removeHash();
    }
  }, [mutation, removeHash, thread.id]);
};

export default useResolveThread;
